import { Injectable } from "@angular/core";
import { AppUppyFile } from "common";
import { AppBarAction, ButtonColor, CommonActionKey, SimpleDialogData } from "common";
import {
  ApplicationFormStepEnum,
  RequiredDocument,
  RequiredDocumentFileUploadModel
} from "../../model/application-form.model";

@Injectable()
export class ApplicationFormFacade {

  provideDialogData(): SimpleDialogData {
    return {
      body:
        "All unsaved changes will be lost. Would you like to save your changes before leaving?",
      title: "Unsaved changes",
      actions: [
        {
          label: "CANCEL",
          buttonColor: ButtonColor.Default,
          actionKey: CommonActionKey.Cancel,
        },
        {
          label: "DISCARD",
          buttonColor: ButtonColor.Default,
          actionKey: CommonActionKey.Discard,
        },
        { label: "SAVE", buttonColor: ButtonColor.Primary, actionKey: CommonActionKey.Save, },
      ],
    };
  }

  getActions(step: ApplicationFormStepEnum): AppBarAction[] {
    switch (step) {
      case ApplicationFormStepEnum.Form:
        return [
          { id: "saveForm", label: "Save", buttonType: "button" },
          {
            id: "next",
            label: "Next",
            buttonType: "submit",
            buttonAppearance: "flat",
            buttonColor: "primary",
          },
        ];
      case ApplicationFormStepEnum.FileUpload:
        return [
          { id: "back", label: "Back", buttonType: "button" },
          { id: "saveFiles", label: "Save", buttonType: "button" },
          {
            id: "submit",
            label: "Submit",
            buttonType: "submit",
            buttonAppearance: "flat",
            buttonColor: "primary",
          },
        ];
      default: {
        console.warn("Wrong step state");
        return [];
      }
    }
  }

  attachFilesToUpload(
    requiredDocument: RequiredDocument,
    newFiles: AppUppyFile[],
    filesToUpload: RequiredDocumentFileUploadModel[]
  ): RequiredDocumentFileUploadModel[] {
    let result = this.updateFilesToUpload(requiredDocument, newFiles, filesToUpload);
    result = this.clearOutEmptyUploadFiles(result);
    return result;
  }

  private updateFilesToUpload(
    requiredDocument: RequiredDocument,
    newFiles: AppUppyFile[],
    filesToUpload: RequiredDocumentFileUploadModel[]
  ): RequiredDocumentFileUploadModel[] {
    let result = [];

    if (!requiredDocument) {
      return result;
    }

    result = [...filesToUpload];

    const found = result.find(
      (c) => c.requiredDocument.id === requiredDocument.id
    );
    if (found) {
      found.filesToUpload = newFiles;
    } else {
      result.push({
        requiredDocument: requiredDocument,
        filesToUpload: newFiles,
      } as RequiredDocumentFileUploadModel);
    }

    return result;
  }

  private clearOutEmptyUploadFiles(
    filesToUpload: RequiredDocumentFileUploadModel[]
  ): RequiredDocumentFileUploadModel[] {
    const result = [...filesToUpload];
    const noFileCheckouts = result.filter(
      (c) => !c.filesToUpload || c.filesToUpload.length === 0
    );
    noFileCheckouts.forEach((noFileCheckout) => {
      result.splice(result.indexOf(noFileCheckout), 1);
    });

    return result;
  }
}
